import { createRouter } from '@tanstack/react-router'

import { queryClient } from '@/lib/query-client'
import { Spinner } from '@/components/ui/spinner'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultPendingComponent: () => (
    <div className="flex items-center gap-2 p-6 text-sm text-muted-foreground">
      <Spinner /> Loading…
    </div>
  ),
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
